<template>
  <Transition
    enter-active-class="transition duration-500 delay-100 ease-smooth"
    enter-from-class="translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition duration-500 ease-smooth"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-full opacity-0">
    <DialogContent
      ref="dialogContentRef"
      :class="[
        'rounded-t-[1.25rem] flex flex-col fixed left-0 bottom-0 right-0 top-6 z-40 md:top-12 overflow-hidden',
        backgroundClass,
      ]"
      :aria-describedby="undefined"
      @pointer-down-outside.prevent>
      <div class="grow-0 w-full flex justify-between items-center p-4 md:p-5">
        <div>
          <slot name="header" />
        </div>
        <DialogClose class="text-white" aria-label="Sluit">
          <Button variant="primary" size="square"><CloseIcon class="w-3 h-3" /></Button>
        </DialogClose>
      </div>
      <div ref="popupElement" class="flex-1 overflow-y-auto">
        <slot />
      </div>
    </DialogContent>
  </Transition>
</template>

<script setup lang="ts">
import type { Domain } from '@gro-up/types'
import { DialogClose, DialogContent } from 'radix-vue'
import { inject, computed, ref, type Ref, provide } from 'vue'

import { Button } from '..'
import { CloseIcon } from '../../icons'

type PagePopupContentProps = {
  /**
   * 'theme' follows the active domain, 'neutral' is the fixed beige shell used on corporate.
   */
  background?: 'theme' | 'neutral'
}

const props = withDefaults(defineProps<PagePopupContentProps>(), {
  background: 'theme',
})

// Inject the domain from the context (provided by DomainContext)
const domain = inject<Ref<Domain | null>>('domain', ref(null))

// Get reference to the dialog content element
const popupElement = ref<HTMLElement>()

// Provide the popup element to its children
provide('popupElement', popupElement)

const backgroundClass = computed(() => {
  if (props.background === 'neutral') {
    return 'bg-head-office-40'
  }

  return domain.value === null ? 'bg-theme-100' : 'bg-theme-10'
})
</script>
